import React from 'react';
import Footer from '../components/Footer';

const CCPA: React.FC = () => {
  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ background: 'linear-gradient(to bottom, #0c0d1f, #1b1324)' }}
    >
      <div className="flex-1 px-6 md:px-12 lg:px-20 py-12">
        <div className="max-w-4xl mx-auto space-y-8 bg-white/5 border border-white/10 rounded-3xl p-8 backdrop-blur">
          <div>
            <p className="text-primary-200 text-sm uppercase tracking-wide mb-2">California Privacy</p>
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">AdSmash CCPA Notice</h1>
            <p className="text-white/70">Effective Date: May 01, 2024</p>
          </div>

          <section className="space-y-4 text-white/80 leading-relaxed">
            <p>
              This California Consumer Privacy Act (“CCPA”) notice supplements the AdSmash Privacy Policy and applies to
              California residents whose personal information we process. The CCPA gives you specific rights over how
              businesses collect, use, and share your data. We respect those rights and explain them below.
            </p>
          </section>

          <section className="space-y-3 text-white/80">
            <h2 className="text-2xl font-semibold text-white mb-2">Categories of information we collect</h2>
            <p>
              In the past 12 months, AdSmash has collected the following categories of personal information for the
              purposes described in our Privacy Policy:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Identifiers (email address, IP address, anonymous installation ID, account credentials).</li>
              <li>Commercial information (purchase history, subscription status, refund requests).</li>
              <li>Internet or network activity (basic log data, device/browser type, crash diagnostics).</li>
              <li>Geolocation data inferred from IP address (city/state level only).</li>
              <li>Payment metadata (billing ZIP, last four digits of card, payment amount).</li>
            </ul>
            <p>We do not collect sensitive biometric data or detailed browsing history.</p>
          </section>

          <section className="space-y-3 text-white/80">
            <h2 className="text-2xl font-semibold text-white mb-2">How we use and share this information</h2>
            <p>
              We use personal information to deliver the AdSmash service, process payments, provide customer support,
              detect fraud, debug issues, and comply with legal obligations. We may share information with service
              providers (e.g., Stripe, PayPal, hosting partners) who perform services on our behalf under strict data
              processing agreements. We do not “sell” personal information as defined by the CCPA, and we do not share
              personal information for cross-context behavioral advertising.
            </p>
          </section>

          <section className="space-y-3 text-white/80">
            <h2 className="text-2xl font-semibold text-white mb-2">Your CCPA rights</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Right to know:</strong> You may request the specific pieces and categories of personal information we have collected about you, along with the sources and purposes.</li>
              <li><strong>Right to delete:</strong> You may ask us to delete personal information we collected, subject to certain exceptions (e.g., required for transactions or legal obligations).</li>
              <li><strong>Right to correct:</strong> You may request that we fix inaccurate information in our records.</li>
              <li><strong>Right to opt out:</strong> Because we do not sell your data, there is no opt-out mechanism necessary.</li>
              <li><strong>Right to non-discrimination:</strong> We will not deny services, charge different prices, or provide different quality because you exercised any privacy right.</li>
            </ul>
          </section>

          <section className="space-y-2 text-white/80">
            <h2 className="text-2xl font-semibold text-white mb-2">How to exercise your rights</h2>
            <p>
              Email <a href="mailto:privacy@adsmash.com" className="text-primary-300">privacy@adsmash.com</a> with the subject line “CCPA Request” and include:
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li>The type of request (know, delete, correct).</li>
              <li>The email address associated with your AdSmash account or purchase.</li>
            </ul>
            <p>
              We may need additional information to verify your identity before fulfilling the request. Authorized agents
              may submit requests on your behalf if they provide proof of authorization. We will confirm receipt within
              10 days and respond within 45 days (or notify you if an extension is needed).
            </p>
          </section>

          <section className="space-y-3 text-white/80">
            <h2 className="text-2xl font-semibold text-white mb-2">Retention</h2>
            <p>
              We retain personal information only as long as necessary to fulfill the purposes described above, comply
              with our legal obligations, resolve disputes, and enforce our agreements. When those purposes are complete,
              we delete or anonymize the information.
            </p>
          </section>

          <section className="space-y-3 text-white/80">
            <h2 className="text-2xl font-semibold text-white mb-2">Contact</h2>
            <p>
              For questions about this notice or to submit a CCPA request, contact us at:
            </p>
            <p className="text-white">
              AdSmash, Inc.<br />
              1200 Market Street, Suite 230<br />
              San Francisco, CA 94102 USA<br />
              Email: <a href="mailto:privacy@adsmash.com" className="text-primary-300">privacy@adsmash.com</a>
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CCPA;

